module.exports = __webpack_public_path__ + "media/images/recruit/section/mv_department_sp11-d6ce21a1c86f21c1051b49e534222868.jpg";